<template>
    <ux-form ref="form" :colon="true" width="400px" :data="formData" :rules="rules" label-width="50px" data-automation="addPush">
        <ux-form-item label="类型" prop="type">
            <ux-select v-model="formData.type" :options="typeList"></ux-select>
        </ux-form-item>
        <ux-form-item label="表达式" prop="expression">
            <ux-input v-model="formData.expression" size="small" :maxlength="127"></ux-input>
        </ux-form-item>
        <ux-form-item label="URL" prop="url" :optionText="false">
            <ux-input v-model="formData.url" size="small" :maxlength="127"></ux-input>
        </ux-form-item>
        <ux-form-item label="描述" start prop="memo">
            <ux-input v-model="formData.memo" type="textarea" size="small" :autosize="{ minRows: 5, maxRows: 5}" resize="none" :maxlength="127" show-word-limit placeholder="不超过127个字符"></ux-input>
        </ux-form-item>
    </ux-form>
</template>

<script>
import { getLocalStorage } from '@l/localStorage.js';
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          user: '',
          type: '',
          expression: '',
          url: '',
          memo: '',
        };
      }
    }
  },

  data() {
    return {
      typeList: [
        {
          label: 'mv',
          value: 'mv',
        },
        {
          label: 'ju',
          value: 'ju',
        }
      ],
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addPush()
    };
  },
  created() {
    this.formData.user = this.formData.user ? this.formData.user : getLocalStorage('userData')['username'];
  },
};
</script>
